import Spline from '@splinetool/react-spline'
import React from 'react'
import { Link } from 'react-router-dom'
import BusinessChat from './BusinessChat' // Импортируем стили из модуля
import styles from './ChatAgent.module.css'

function ChatAgent() {
	return (
		<div className={styles.container}>
			<header className={styles.header}>
				<Link to='/' className={styles['logo-link']}>
					<h1>MaxSimple</h1>
				</Link>
				<a href='https://crm.staging.svoimax.ru/' target='_blank' className='btn'>
					Войти
				</a>
			</header>

			<main className={styles.content}>
				<div className={styles['spline-scene']}>
					<Spline scene='/scene.splinecode' />
				</div>
				<div className={styles['text-section']}>
					<BusinessChat />
				</div>
			</main>

			<footer className={styles.footer}>
				<p>2025 © ООО «Максимпл»</p>
				<div className={styles.links}>
					<Link to='/terms' className={styles.link}>
						Условия и положения
					</Link>
					<Link to='/privacy' className={styles.link}>
						Политика конфиденциальности
					</Link>
				</div>
			</footer>
		</div>
	)
}

export default ChatAgent
